module.exports = __webpack_public_path__ + "static/media/互动手套.cd5116b9.png";